import React, { FunctionComponent } from 'react';

type B64imgprops = {
  data: string,
};

// eslint-disable-next-line jsx-a11y/alt-text
const b64img: FunctionComponent<B64imgprops> = ({ data }) => <img src={`data:image/svg+xml;base64,${data}`} />;
export default b64img;
